import { ApiTypes } from '@wix/social-groups-api/dist/src/types';
import * as React from 'react';
import { GroupActionsConsumer } from './GroupActionsContext';

export interface GroupApps {
  configureApps(apps: ApiTypes.v1.GroupApp[]);
}

export const withGroupApps = <P extends GroupApps>(
  WrappedComponent: React.ComponentType<P>,
): React.FC<Omit<P, keyof GroupApps>> => props => (
  <GroupActionsConsumer>
    {({ configureApps }) => (
      <WrappedComponent {...(props as P)} configureApps={configureApps} />
    )}
  </GroupActionsConsumer>
);
